import { createComponent } from "@front/utils/alpine";
import { debounce } from "lodash-es";

export default createComponent(({ $persist, $defaults }) => ({
    wrapperEl: null as null | HTMLElement,
    noPrev: true,
    noNext: false,

    prev () {
        this.wrapperEl.scrollBy({
            left: -this.wrapperEl.querySelector(':scope > *').offsetWidth,
            behavior: 'smooth',
        });
    },

    next () {
        this.wrapperEl.scrollBy({
            left: this.wrapperEl.querySelector(':scope > *').offsetWidth,
            behavior: 'smooth',
        });
    },

    setup () {
        this.wrapperEl = this.$el.querySelector(':scope > *:not(button)');

        const updateScroll = () => {
            const { scrollLeft, offsetWidth, scrollWidth } = this.wrapperEl;

            this.noPrev = scrollLeft == 0;
            this.noNext = scrollWidth - scrollLeft - offsetWidth == 0;
        }

        this.wrapperEl.addEventListener('scroll', debounce(updateScroll, 250));
        updateScroll();
    },
}));
